import { Box, useScaleFactor } from "arkh";
import React from "react";
import { Image } from "expo-image";
import { graphql, useFragment } from "react-relay";
import { getImagesFromCondition } from "./getImagesFromCondition";
import { WidgetWeatherConditionIcon_WeatherOccasion$key } from "./__generated__/WidgetWeatherConditionIcon_WeatherOccasion.graphql";

export function IconComponent(props: {
  occasion: WidgetWeatherConditionIcon_WeatherOccasion$key;
}) {
  const { condition } = useFragment(
    graphql`
      fragment WidgetWeatherConditionIcon_WeatherOccasion on WidgetWeatherOccasion {
        condition
      }
    `,
    props.occasion
  );

  const icon = getImagesFromCondition(condition, false).icon;

  const scale = useScaleFactor();
  return (
    <Box style={{ width: "20%", alignItems: "center" }}>
      <Image
        source={icon}
        style={{
          width: Math.round(40 * scale),
          height: Math.round(40 * scale),
        }}
      />
    </Box>
  );
}
